import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleCategoryDto } from '../../dtos/create-vehicle-category.dto';
import { UpdateVehicleCategoryDto } from '../../dtos/update-vehicle-category.dto';
import { createVehicleCategorySchema } from '../schemas/create-vehicle-category.schema';
import { updateVehicleCategorySchema } from '../schemas/update-vehicle-category.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleCategoryDto | UpdateVehicleCategoryDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleCategorySchema if 'id' is present
		validationResult = updateVehicleCategorySchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleCategorySchema if 'id' is not present
		validationResult = createVehicleCategorySchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
